import { useCallback, useEffect, useState } from "react";
import Logo from "../icons/Logo";
import GearIcon from "../icons/GearIcon";
import "./index.scss";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../context/DataProvider";
import { useNavigate } from "react-router-dom";

const FeaturedSolutions = ({children} : any) => {
    const navigate = useNavigate();
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent, location])
    const [active, setActive]  = useState<boolean>(false);
    useEffect(()=>{
        setTimeout(()=>{
            setActive(true);
        }, 1000)
    }, [])
    return(
        <div id="featured-solutions" className={`featured-solutions ${active && "slide-up"}`}>
            <div className="header-box">
                Featured Solutions
            </div>
            <div className="left-side">
                <div className="row">
                    <GearIcon />
                    <span>
                        Plus integrations with{'\n'}
                        existing solutions
                    </span>
                </div>
                <div className="f-logo" onClick={()=>{
                    _logEvent('click', "Featured Solutions", "Agilysys");
                    addFlow("Agilysys");
                    navigate("/aboutus/agilysys")
                }}><Logo /></div>
            </div>
            <div className="right-side">
                {children}
            </div>
        </div>
    )
}

export default FeaturedSolutions;